import React from 'react';
import { FormattedCurrency } from '@qover/react-intl';
import { Heading1, Heading4, Sitemap } from '@qover/typography';
import PaymentOkIcon from '@qover/icons/PaymentOkIcon';
import messages from './confirmationHeader.messages';
import {
  PaymentSuccessContainer,
  SelectedProgram,
} from './confirmationHeader.styles';

export type ConfirmationHeaderProps = {
  paymentFrequency?: React.ReactNode;
  paymentMessage: React.ReactNode;
  renderTitle?: React.FC;
  subtitle?: React.ReactNode;
  title?: React.ReactNode;
  price?: number;
  variant?: React.ReactNode;
};

export function ConfirmationHeader(props: ConfirmationHeaderProps) {
  const Title = props.renderTitle || Heading1;

  return (
    <>
      <Title>{props.title || messages.title}</Title>
      {props.subtitle && <Heading4>{props.subtitle}</Heading4>}
      <PaymentSuccessContainer>
        <PaymentOkIcon />
        {props.paymentMessage}
      </PaymentSuccessContainer>
      <SelectedProgram>
        {props.variant && (
          <Heading4 as="span" className="font-normal">
            {props.variant}
          </Heading4>
        )}
        {props.price && props.paymentFrequency && (
          <div className="text-right">
            <Heading4 as="div" data-test="confirmation.price">
              <FormattedCurrency value={props.price} />
            </Heading4>
            <Sitemap>{props.paymentFrequency}</Sitemap>
          </div>
        )}
      </SelectedProgram>
    </>
  );
}
